/** Historical source evidence is not a payment or a cash receipt. */
export interface InvoiceImportEvidence {
  format: "freshbooks" | "signalbill";
  fileSha256: string;
  sourceNumber: string;
  status: "draft" | "issued" | "overdue" | "paid";
  paidOn: string | null;
}
interface FinancialInvoice {
  documentState: "draft" | "issued";
  grandTotalMinor: number;
  paidMinor?: number;
  importEvidence?: InvoiceImportEvidence;
  historicalSettlement?: { paidOn: string | null };
}
export function hasHistoricalSettlement(invoice: FinancialInvoice): boolean {
  return invoice.documentState === "issued" && (invoice.importEvidence?.status === "paid" || invoice.historicalSettlement !== undefined);
}
export function sourceReportedSettlementMinor(invoice: FinancialInvoice): number {
  return hasHistoricalSettlement(invoice) ? Math.max(0, invoice.grandTotalMinor - (invoice.paidMinor ?? 0)) : 0;
}
export function invoiceOutstandingMinor(invoice: FinancialInvoice): number {
  return Math.max(0, invoice.grandTotalMinor - (invoice.paidMinor ?? 0) - sourceReportedSettlementMinor(invoice));
}
export function isSourceReportedPaid(invoice: FinancialInvoice): boolean {
  return hasHistoricalSettlement(invoice);
}
export function importDescription(evidence: InvoiceImportEvidence): string {
  return `Imported from ${evidence.format === "freshbooks" ? "FreshBooks" : "SignalBill CSV"}${evidence.status === "paid" ? ` · Paid · Source reported${evidence.paidOn ? ` (${evidence.paidOn})` : ""}. No payment transaction was imported.` : ` · Source status: ${evidence.status}.`}`;
}
